<template>
    <div class="layout">
        <Layout class="layouts">
            <Sider hide-trigger :style="{height:($store.state.tableHight - 65) + 'px'}" class="rx-sider">
                <Side></Side>
            </Sider>
            <Layout>
                <headers></headers>
                <Content class="em-body" :style="{height:($store.state.tableHight - 65) + 'px'}">
                    <Row>
                        <Col span="24">
                            <div class="em-list-header">
                                <div class="em-list-header-search">
                                    <Input class="search-input" size="small" clearable v-model="search.title" placeholder="请输入名称" />
                                    &nbsp;&nbsp;
                                    <DatePicker class="search-select" size="small" v-model="search.time" clearable type="daterange" format="yyyy-MM-dd"  placeholder="到期时间" />
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.type_id"  clearable filterable  placeholder="证书类型">
                                        <Option :value="item.id" v-for="(item,index) in typeList" :key="index">{{item.name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select size="small" v-model="search.status" clearable placeholder="状态" class="search-select">
                                        <Option :value="3" >开启</Option>
                                        <Option :value="2" >禁用</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Button size="small" @click="onSearch"><Icon type="ios-search" /> 搜索</Button>
                                </div>
                                <div class="rx-list-header-btn">
                                    <ButtonGroup >
                                        <Button type="primary" size="small" class="text-font-sm" @click="CreateData"><Icon type="md-add" /> 新增</Button>
                                        <Button type="warning" size="small" class="text-font-sm" @click="reSet"><Icon type="md-refresh" /> 刷新</Button>
                                    </ButtonGroup>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <Table row-key="admin_id" ref="selection" stripe :loading="$store.state.loading" :columns="columns" :data="dataList.data" no-data-text="暂无数据记录">
                                <template #title="{ row }">
                                    <span class="text-primary cursor " @click="showData(row.id)">{{row.title}}</span>
                                </template>
                                <template #type_id="{ row }">
                                    <Tag >{{row.type_name}}</Tag>
                                </template>
                                <template #is_alert="{ row }">
                                    <Tag v-if="row.is_alert === 1" color="red">提醒</Tag>
                                    <Tag v-else>不提醒</Tag>
                                </template>
                                <template #alert_day="{ row }">
                                    <span v-if="row.is_alert === 1">到期前 <strong class="text-primary">{{row.alert_day}}</strong> 天提醒</span>
                                    <span v-else>-</span>
                                </template>
                                <template #remark="{ row }">
                                    <div class="d-width" :title="row.remark">
                                        {{row.remark}}
                                    </div>
                                </template>
                                <template #status="{ row }">
                                    <Badge v-if="row.status === 1" status="processing" text="审核" />
                                    <Badge v-else-if="row.status === 2" status="error" text="禁用" />
                                    <Badge v-else-if="row.status === 3" status="success" text="开启" />
                                    <Badge v-else status="warning" text="其他" />
                                </template>
                                <template #action="{ row, index }">
                                    <a class="text-font-sm text-primary" @click="EditData(row.id)">编辑</a>
                                    <Divider type="vertical" v-if="$store.state.userinfo.group_id === 1" />
                                    <a class="text-font-sm text-999" @click="DelData(row.id , index)" v-if="$store.state.userinfo.group_id === 1" >删除</a>
                                </template>
                            </Table>
                            <div class="em-page em-flex">
                                <Page size="small" :total="dataList.total" :current="page" :page-size="pageSize" show-total @on-change="ChangePage" />
                            </div>
                        </Col>
                    </Row>

                    <!-- 创建/编辑  -->
                    <add-modal v-if="is_create" ref="AddRef" @trueHandler="SaveData"></add-modal>

                </Content>
            </Layout>
        </Layout>
    </div>
</template>

<script>
import '@/assets/style.css'
import {deleteCert, getCertConfig, getCertList} from '@/apis/cert'
import Headers from "@/components/public/Headers";
import Side from "@/components/public/Side";
import AddModal from "./Create";
export default {
    name: "Cert",
    components: {
        Headers, Side, AddModal
    },
    data () {
        return {
            search: {
                title : '',
                type_id : '',
                status : '',
                time : []
            },
            typeList : [],
            page : 1,
            pageSize : 10,
            dataList : [],
            columns: [
                {
                    title: '名称',
                    key: 'title',
                    slot: 'title',
                    minWidth: 200,
                },
                {
                    title: '类型',
                    key: 'type_id',
                    slot: 'type_id',
                    width: 200
                },
                {
                    title: '提醒',
                    key: 'is_alert',
                    slot: 'is_alert',
                    width: 200
                },
                {
                    title: '提醒日期',
                    key: 'alert_day',
                    slot: 'alert_day',
                    width:200
                },
                {
                    title: '到期日期',
                    key: 'end_time',
                    width: 200
                },
                {
                    title: '备注',
                    key: 'remark',
                    slot: 'remark',
                    width: 200
                },
                {
                    title: '状态',
                    key: 'status',
                    slot : 'status',
                    width:120
                },
                {
                    title: '操作',
                    key: 'action',
                    slot : 'action',
                    align: 'center',
                    width : 110,
                    fixed : 'right'
                }
            ],
            is_create : false,

        }
    },
    created(){
        this.getConfig();
        this.GetList();
    },
    mounted(){
        let that = this;
        that.HeightInit();
    },
    computed: {

    },
    methods: {
        getConfig(){
            let that = this;
            getCertConfig().then(e=>{
                that.typeList = e.data.typeList ?? [];
            })
        },
        /**
         功能：搜索
         time: 2025-15-02 16:15:50
         **/
        onSearch(){
            let that = this;
            that.page = 1;
            that.GetList();
        },
        /**
         功能：
         time: 2025-17-02 16:17:18
         **/
        reSet(){
            let that = this;
            that.page = 1;
            that.search = {
                title : '',
                type_id : '',
                status : '',
                time : []
            };
            that.GetList();
        },
        /**
         功能：
         time: 2025-09-01 18:09:28
         **/
        GetList(){
            let that = this;
            const params = {
                pageSize : that.pageSize,
                page : that.page,
                search : that.search
            };
            that.$store.commit('SET_LOADING' , true);
            getCertList(params).then(e=>{
                that.dataList = e.data;
            })
        },
        ChangePage (e) {
            let that = this;
            that.page = e;
            that.GetList();
        },

        /**
         功能：创建路由
         time: 2025-26-02 09:26:21
         **/
        CreateData(){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.add();
            })
        },
        /**
         功能：编辑路由
         time: 2025-26-02 09:26:29
         **/
        EditData(id){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.edit(id);
            })
        },
        /**
         功能：路由操作返回
         time: 2025-26-02 09:26:53
         **/
        SaveData(){
            let that = this;
            that.GetList();
        },
        /**
         功能：删除路由
         time: 2025-01-02 12:01:16
         **/
        DelData(id){
            let that = this;
            if(!id){
                that.$Message.error({ background: true,duration:3, content:'记录不存在'});
                return;
            }
            that.$Modal.confirm({
                title: '删除记录',
                content: '此操作将删除记录不可恢复, 是否继续?',
                onOk: () => {
                    deleteCert(id).then( e =>{
                        that.$Message.success({ background: true,duration:3, content:e.msg});
                        that.GetList();
                    })
                },
                onCancel: () => {}
            });
        },
        HeightInit(){
            this.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            // 动态计算 table 的高度重新赋值
            const that = this;
            window.onresize = function () {
                that.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            }
        }
    }
}
</script>

<style scoped lang="less" rel="stylesheet/less">

</style>
